export const cookieNames = {
  cookieControl: "cookie-control",
};
